module.exports = __webpack_public_path__ + "img/Up-2.5b94cbfb.svg";